import { type PopupProps, Popup } from '@/components/Popups';
import type { EntityData } from '@/services/api/types';
import WelcomeContent from './Welcome.styles';
import Button from '@CS/components/Button';
import { useTranslations } from '@/hooks';
import { useState } from 'react';

type WelcomeProps = PopupProps & {
  data?: EntityData;
};

export const Welcome = ({ data, ...props }: WelcomeProps) => {
  const [title, description, button] = useTranslations([
    '01WelcomePopupTitle',
    '01WelcomePopupDescription',
    '01WelcomePopupCta'
  ]);

  const [close, setClose] = useState(false);
  const onClick = () => setClose(true);

  return (
    <Popup close={close} overlay={false} hideClose {...props}>
      <WelcomeContent>
        <h2>{title}</h2>
        <p>{description}</p>
        <Button text={button} onClick={onClick} />
      </WelcomeContent>
    </Popup>
  );
};
